import { useContext, useEffect } from "react";
import { JSONataEditorContext } from "../contexts/JSONataEditorContext";
import { JSONataPanel } from "./JSONataPanel/JSONataPanel";

export function JSONataRunner(props) {
  const { value, script, setOutput, bindings, original$ } = useContext(JSONataEditorContext)
  let input;
  useEffect(() => {
    async function evalExp() {
      try {
        if (script === '') {
          setOutput('')
          return
        }
        if (bindings && bindings.trim() !== '') {
          try {
            // Try to parse bindings as a function to validate syntax
            const testBindings = eval(`(${bindings})`);
            if (typeof testBindings !== 'object' || testBindings === null) {
              setOutput('Error: Bindings must be a valid object');
              return;
            }
          } catch (err) {
            setOutput('Error in bindings: ' + err.message);
            return;
          }
        }

        if (typeof value === "string") {
          const code = `
                const bindingsObj = ${bindings}
                self.onmessage = async (e) => {
                  const {script,input} = e.data
                  let result;
                  try{
                  importScripts('https://cdn.jsdelivr.net/npm/jsonata/jsonata.min.js');
                  const expr = jsonata(script)
                  expr.registerFunction('base64encode', (str) => {
                          try {
                            return btoa(unescape(encodeURIComponent(str)));
                          } catch (e) {
                            throw new Error('Invalid input for base64encode: ' + e.message);
                          }
                        }, '<s:s>');
                  expr.registerFunction('base64decode', (str) => {
                          try {
                            return decodeURIComponent(escape(atob(str)));
                          } catch (e) {
                            throw new Error('Invalid input for base64decode: ' + e.message);
                          }
                        }, '<s:s>');
                              
                  for(const key in bindingsObj){
                      expr.registerFunction(key,bindingsObj[key]);
                  }
                    result = await expr.evaluate(input);
                }catch(err){
                    result = "Error: " + err.message
                }
                    self.postMessage(result)

                };`
          const blob = new Blob([code], { type: 'application/javascript' });
          const url = URL.createObjectURL(blob)
          const jsonataWorker = new Worker(url)
          function postmyMessage(msg) {
            return new Promise((resolve) => {
              jsonataWorker.onmessage = (e) => { resolve(e.data) }
              jsonataWorker.postMessage(msg)
            })
          }
          try {
            if (value !== "") {
              input = JSON.parse(value);
            }
          } catch (e) {
            return;
          }
          const workerMsg = await postmyMessage({ script, input })
          if (workerMsg === undefined) {
            setOutput('ERROR: JSONata expression is invalid')
          } else if (typeof workerMsg === 'string') {
            setOutput(workerMsg)
          } else {
            setOutput(JSON.stringify(workerMsg, null, 2))
          }
        }

      } finally {
        if (original$ !== undefined) {
          window.$ = original$;
        } else {
          delete window.$;
        }
      }
    }
    evalExp()
  }, [script, bindings, value]
  )
  return (
    <JSONataPanel {...props} />)
}